import { memo } from "react";
import { Button } from "@/components";
import { usePortfolioStore } from "@/zustand/PortfolioStore";

export const PositionTypeSelector = memo(() => {
    const { positionType, setPositionType } = usePortfolioStore();
    return (
        <div className="flex w-full gap-1 bg-card p-1 bg-light rounded-lg">
            <Button
                variant={positionType === "locked" ? "filter-active" : "filter-inactive"}
                onClick={() => setPositionType("locked")}
                size="md"
                fullWidth
            >
                Locked (liUSD)
            </Button>
            <Button
                variant={positionType === "staked" ? "filter-active" : "filter-inactive"}
                onClick={() => setPositionType("staked")}
                size="md"
                fullWidth
            >
                Staked (siUSD)
            </Button>
        </div>
    );
});

PositionTypeSelector.displayName = "PositionTypeSelector";
